import { render } from "./AppLayout_12_3_9_12.vue?vue&type=template&id=15510d57&scoped=true"
import script from "./AppLayout_12_3_9_12.vue?vue&type=script&lang=js"
export * from "./AppLayout_12_3_9_12.vue?vue&type=script&lang=js"

import "./AppLayout_12_3_9_12.vue?vue&type=style&index=0&id=15510d57&scoped=true&lang=css"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15510d57"]])

export default __exports__